<template>
  <div id="header">
    <div class="header_fundo">
      <img
        src="../src/assets/logo-jurisprudencia.png"
        alt="Tribunal de contas - logo"
        style="max-width: 90%;height: auto;margin-left: 1rem;"
        />
      </a>
      <ul id="landing-menu" style="margin-left: 45%;">
        <li v-for="(item, i) in items" :key="item.label || i">
          <router-link v-if="item.to" :to="item.to">
            <i :class="item.icon"></i>
            <span> {{ item.label }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
    },
  },
  created() {
    console.log(this.item);
  },
};
</script>


<style>

  .header_fundo {
    background: #335E82;
    display: flex;
     padding: 1rem 0rem 1rem 1rem;
  }



</style>

